import { useNavigate, useOutletContext, useParams } from 'react-router-dom'

import { useQuery } from '@apollo/client'
import { QuotesListPageDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useEffect } from 'modules/core/hooks/useEffect'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'

import { QuotesListTable } from 'modules/finance/components/Quotes/QuotesListTable'
import { SalesRootPageOutletContext } from 'modules/finance/pages/SalesRootPage'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

const QuotesListPage = () => {
  const {
    company: { id: companyId },
    access,
  } = useCurrentSession()
  const { navigation } = useNavigation()
  const navigate = useNavigate()
  const { dealId } = useParams()
  const { routesVisibility: salesRootVisibility } = useOutletContext<SalesRootPageOutletContext>()
  const dealIdNumber = dealId ? Number(dealId) : -1
  const { data, error, loading } = useQuery(QuotesListPageDocument, {
    variables: {
      dealId: dealIdNumber,
      skipDeal: dealIdNumber == -1,
    },
  })
  const authorized = salesRootVisibility.finance._policies.sidebarSeeFinanceQuotesSubLevelItem.can
  const dealName = data?.finance?.deal?.name
  const canCreateQuote = data?.finance?._policies?.quotesCreate?.can ?? false

  useEffect(() => {
    if (Number(dealId)) {
      track(trackingEvents.accounting.deals.viewDealQuotes)
    } else {
      track(trackingEvents.accounting.quotes.viewQuotesPage)
    }
  }, [dealId])

  const handleClickAdd = () => {
    if (canCreateQuote) {
      return
    }
    navigate(navigation.finance.sales.quotes.new.fullPath(), {
      state: { dealId: Number(dealId) },
    })
  }

  return (
    <ResponsivePage.Body authorized={authorized} error={error} loading={loading} variant="full">
      <QuotesListTable
        companyId={companyId}
        locale={access.locale}
        dealId={dealId ? Number(dealId) : undefined}
        onClickAdd={handleClickAdd}
        showCustomerColumn
        canCreateQuote={canCreateQuote}
        dealName={dealName}
      />
    </ResponsivePage.Body>
  )
}

export default QuotesListPage
